export default __webpack_public_path__ + "681898df9dde4d733e64d043e69bd21e.gif";